// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"PY-z","subtitle":"QY-z","wrapper":"RY-z","leftArrow":"SY-z","rightArrow":"TY-z"};